// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js!../../node_modules/@swisscom/sdx/dist/css/sdx.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../node_modules/css-loader/dist/cjs.js!./utils.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `header.shrink-0 {
  background-color: #fff;
  border-bottom: 1px solid var(--sdx-color-gray-tint-7, #e4e9ec);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.image-preview-box {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  background-color: var(--sdx-color-gray-tint-8, #f5f5f5);
  border: 1px solid var(--sdx-color-gray-tint-7, #e4e9ec);
  height: 160px;
  max-width: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-preview-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.tiptap ul {
  list-style-type: disc !important;
  padding-left: 1.5rem !important;
  margin: 0.4rem 0 !important;
}

.tiptap ol {
  list-style-type: decimal !important;
  padding-left: 1.5rem !important;
  margin: 0.4rem 0 !important;
}

.tiptap li {
  display: list-item !important;
}

/* Disable focus field in rich text input field */
.ProseMirror:focus {
  outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/styles/globals.css"],"names":[],"mappings":"AAGA;EACE,sBAAsB;EACtB,8DAA8D;EAC9D,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uDAAuD;EACvD,uDAAuD;EACvD,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf","sourcesContent":["@import '@swisscom/sdx/dist/css/sdx.css';\n@import 'utils.css';\n\nheader.shrink-0 {\n  background-color: #fff;\n  border-bottom: 1px solid var(--sdx-color-gray-tint-7, #e4e9ec);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.image-preview-box {\n  position: relative;\n  border-radius: 12px;\n  overflow: hidden;\n  background-color: var(--sdx-color-gray-tint-8, #f5f5f5);\n  border: 1px solid var(--sdx-color-gray-tint-7, #e4e9ec);\n  height: 160px;\n  max-width: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.image-preview-box img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.tiptap ul {\n  list-style-type: disc !important;\n  padding-left: 1.5rem !important;\n  margin: 0.4rem 0 !important;\n}\n\n.tiptap ol {\n  list-style-type: decimal !important;\n  padding-left: 1.5rem !important;\n  margin: 0.4rem 0 !important;\n}\n\n.tiptap li {\n  display: list-item !important;\n}\n\n/* Disable focus field in rich text input field */\n.ProseMirror:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
